<template>
  <el-popover placement="bottom" width="400" v-model="visible">

    <el-button slot="reference">选择项目</el-button>
    <div style="height: 400px;overflow: auto;">
      <el-tree
        ref="tree"
        :props="props"
        :load="loadNode"
        :default-checked-keys="keys"
        node-key="id"
        lazy
        show-checkbox>
      </el-tree>
    </div>
    <div class="txt-right pdt-10">
      <!--<el-button type="primary" @click="setCheckedNodes">选中</el-button>-->
      <el-button type="primary" @click="getCheckedNodes">确定</el-button>
    </div>
  </el-popover>
</template>

<script>
  import {AD_PATH} from "../store/action-path";

  export default {
    name: "DropProjectTree"
    , props: ["projects"]
    , data() {
      return {
        props: {
          label: "name"
          , isLeaf: 'leaf'
        }
        , visible: false
        , cacheProjects:[]
      }
    }

    ,computed:{
      keys(){
        let keys = [];
        this.projects.forEach(item => {
          keys.push(item.id)
        });
        return keys
      }
    }
    , methods: {
      loadNode(node, resolve) {

        let url = `${AD_PATH}/core/admin/advertising/city/etc/tree`;
        let self = this;
        if (node.level === 0) {
          this.axios.post(url + '?parentId=0&type=1').then(result => {
            resolve(result.data)
          });
        } else {
          this.axios.post(url, {parentId: node.data.id, type: node.level + 1}).then(result => {
            let treeData = result.data;
            if (node.level === 2) {
              treeData.forEach((item) => {
                item.leaf = true;
                if(self.keys.indexOf(item.id)>-1){
                  item.checked = true;
                }
              })
            }
            resolve(treeData)
          })
        }
      }
      , getCheckedNodes() {
        this.cacheProjects = this.$refs.tree.getCheckedNodes(true, false);
        this.$emit('selected', this.cacheProjects);
        this.visible = false;
        this.cacheProjects.forEach(item => {
          this.$refs.tree.setChecked(item, false, true)
        });
      }
      ,setCheckedNodes(){
        this.projects.forEach(item => {
          this.$refs.tree.setChecked(item.id, true, true)
        })
      }
    }

    , watch: {
      visible(newVal) {
        if (!newVal) {
          this.$refs.tree.setCheckedNodes(this.cacheProjects)
        }else {
          // 把父组件的定义为选中的项目再次选中
          this.projects.forEach(item => {
            this.$refs.tree.setChecked(item.id, true, true)
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>